// Store Functions
import { mapGetters } from 'vuex'

// Graph Card Components
import ScaleTabs from '../component/ScaleTabs'
import DatePicker from '../component/DatePicker'
import Statistics from '../component/Statistics'

// Types of Graph Templates
import Graph1D from '../Graph1D'
import Graph2D from '../Graph2D'
import Graph3D from '../Graph3D'

// Types of Graph (Vitals)
import StatusGraph1D from '../StatusGraph1D'
import CountGraph1D from '../CountGraph1D'
import BarGraph2D from '../BarGraph2D'

// Types of Graph (Lifestyle)
import FoodGraph1D from '../FoodGraph1D'
import WaterGraph1D from '../WaterGraph1D'
import ExcretionGraph1D from '../ExcretionGraph1D'
import EnergyGraph2D from '../EnergyGraph2D'

import NutritionGraph2D from '../NutritionGraph2D'
import NutritionLegend from '../component/NutritionLegend'

// Scales for graphs
import scales from '../config/scales'

// Utility function for rounding days up/down
import nearestDay from '../util/nearest-day'
const oneDay = 86400000

/**
 * @define		Graph Card
 * @desc 		The common definition for creating Graph Card.
 */
export default {
	name: 'graph-card',

    props: {
		/**
		 * @prop 	data
		 * @type 	Array
		 * @desc 	data to render on the graph SVG
		 * @required
		 */
	    data: {
	        type: Array,
	        required: true
		},

		/**
		 * @prop 	width
		 * @type 	Number
		 * @desc 	width for graph SVG
		 * @required
		 */
	    width: {
	        type: Number,
	        default: 1000
		},

		/**
		 * @prop 	height
		 * @type 	Number
		 * @desc 	height for graph SVG
		 * @required
		 */
	    height: {
	        type: Number,
	        default: 200
		},

		/**
		 * @prop 	id
		 * @type 	String
		 * @desc 	Chart ID for persistent storage of selected state
		 * @required
		 */
		id: {
			type: String
		},
		/**
		 * Scale for the graph 
		 * @prop inputScale
		 * 
		 * @values `weekly`, `biweekly`, `monthly`, `quarterly`
		 * 
		 */
		inputScale: {
			type: String
		}
	},

	/**
	 * @function 	data
	 */
	data() {
		// The base data object
		var data = { scales },
		 	today = new Date().getTime(),
			chartState

		if (this.id && this.$store.state.chartState)
			chartState = this.$store.state.chartState[this.id]


		if (chartState) {
			if (chartState.scale != null && chartState.scale >= 0 && chartState.scale < scales.length)
				data.scale = scales[chartState.scale]
			else
				data.scale = scales[1]
			data.date = new Date(chartState.date || (today - today % oneDay + oneDay))
		}
		else {
			data.scale = scales[1]
			data.date = new Date(today - today % oneDay + oneDay)
		}
		if(this.inputScale)
			data.scale = scales.find((scale) => scale.key === this.inputScale)
		return data
	},

	computed: {
		// /**
		//  * @function 	mapGetters
		//  * @desc 		To use functions from store
		//  * @return 		{function}s from store: getChartState()
		//  */
		// ...mapGetters([
		// 	'getChartState'
		// ]),

		/**
		 * @function 	chartState
		 * @desc 		To identify the state of the chart
		 * @return 		{function}s from store: getChartState()
		 */
		chartState() {
			if (this.id)
				return this.getChartState(this.id)
			else
				return null
		},

		/**
		 * @function 	startDate
		 * @desc 		starting Date of the graph SVG
		 * @return 		{Date} of starting date w.r.t interval selected
		 */
		startDate() {
			return new Date(this.date.getTime() - this.interval)
		},

		/**
		 * @function 	binWidth
		 * @desc 		get spacing between dates w.r.t. the scale
		 * @return 		{Number} width of the scale selected for graph SVG
		 */
		binWidth() {
			return this.scale.binWidth
		},

		/**
		 * @function 	intervalDays
		 * @desc 		total number of dates covered
		 * @return 		{Number} length of scale selected
		 */
		intervalDays() {
			return this.scale.length
		},

		/**
		 * @function 	intervalDays
		 * @desc 		total number of days covered
		 * @return 		{Number} total number of days shown in the graph SVG
		 */
		interval() {
			return this.intervalDays * oneDay
		},

		/**
		 * @function 	intervalGap
		 * @desc 		total number of days skipped
		 * @return 		{Number} total number of days skipped in the graph SVG
		 */
		intervalGap() {
			return this.scale.binWidth * oneDay
		}
	},

	methods: {
		/**
		 * @function 	setScale
		 * @desc 		change the scale type
		 */
		setScale(scale) {
			this.scale = scale
			this.updateState()
		},

		/**
		 * @function 	next
		 * @desc 		change the dates to next set of dates w.r.t. the interval
		 */
		next() {
			var now = new Date().getTime()
			now = new Date(now - now % oneDay + oneDay)

			this.date = new Date(this.date.getTime() + this.interval)
			if (this.date.getTime() > now.getTime()) {
				this.date = now
			}
			this.updateState()
		},

		/**
		 * @function 	next
		 * @desc 		change the dates to prev set of dates w.r.t. the interval
		 */
		previous() {
			this.date = new Date(this.date.getTime() - this.interval)
			this.updateState()
		},

		/**
		 * @function 	updateState
		 */
		updateState() {
			// if (this.id)
			// 	this.$store.commit('setChartState', {
			// 		id: this.id,
			// 		scale: (this.scale && this.scale.index != null) ? this.scale.index : 1,
			// 		date: this.date.getTime()
			// 	})
			// else
			// 	console.log('Chart needs ID to save state')
		}
	},

	components: {
		ScaleTabs,
		DatePicker,
		Statistics,

		Graph1D,
		Graph2D,
		Graph3D,

		StatusGraph1D,
		BarGraph2D,
		CountGraph1D,

		FoodGraph1D,
		WaterGraph1D,
		ExcretionGraph1D,
		EnergyGraph2D,

		NutritionGraph2D,
		NutritionLegend
	}
}
